import { isNil } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const SearchModalResultsHeading = ({ currentSearchValue }) => (
  <>
    <p className="SearchModalHeader__label">
      {isNil(currentSearchValue)
        ? I18n.localize('searchBar.topSuggestions')
        : I18n.localize('searchBar.results')}
    </p>
    <style jsx>
      {`
        .SearchModalHeader__label {
          font-size: ${Theme.get('font-size-small-px')};
          text-transform: uppercase;
          font-weight: ${Theme.get('font-weight-semi-bold')};
          letter-spacing: ${Theme.get('letter-spacing-large-px')};
          padding: ${Theme.get('spacing') * 1.5}px 0;
          color: ${Theme.get('colors-black-40')};
        }
      `}
    </style>
  </>
);

SearchModalResultsHeading.propTypes = {
  currentSearchValue: PropTypes.string,
};

export default SearchModalResultsHeading;
